interface Props {
  eyebrow: string;
  eyebrowIcon?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeader({
  eyebrow,
  eyebrowIcon = "ri-alert-line",
  title,
  desc,
  align = "center",
}: Props) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} gap-3 mb-10`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-semibold tracking-wide text-accent-900 whitespace-nowrap">
        <i className={`${eyebrowIcon} text-sm w-4 h-4 flex items-center justify-center`} aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="text-2xl md:text-4xl leading-snug text-foreground-950">{title}</h2>
      {desc ? <p className="max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p> : null}
    </div>
  );
}